// extracted by mini-css-extract-plugin
export default {"tooltip":"bV-z","arrow":"cV-z"};